<div class="pt-8 pb-16 px-2 md:py-[30px] md:px-[50px]">
  <ng-container *ngIf="step === 1">
    <div>
      <img class="w-[53px] h-[53px]" src="/assets/v4/icon-ctrip-color-bg.svg" alt="" />
      <img class="mx-2" src="/assets/v4/icon-link-arrow.svg" alt="" />
      <img class="w-[53px] h-[53px]" src="/assets/v4/icon-hostex-color.svg" alt="" />
    </div>

    <div class="text-l font-bold mt-[30px]">
      {{ "channel-connect_ctrip_html_标题" | translate }}
      <!-- Connect with Agoda -->
    </div>

    <div class="text-m mt-[30px]">
      {{ "channel-connect_ctrip_html_说明" | translate }}
      <!-- Hostex is an official Agoda connectivity partner, so we can connect with your account reliably and securely. -->
    </div>

    <div class="text-m mt-[30px]">
      <div>{{ "channel-connect_ctrip_html_说明tip" | translate }}</div>
      <div [innerHTML]="'channel-connect_ctrip_html_说明1' | translate"></div>
      <div [innerHTML]="'channel-connect_ctrip_html_说明2' | translate"></div>
      <div [innerHTML]="'channel-connect_ctrip_html_说明3' | translate"></div>
      <!-- If you use Agoda homes to manage your listings, <span class="font-bold">please be aware</span> that due to its
      inability to properly display third-party modifications to the availability of the listings (the status of
      Rateplan cannot be displayed), you may see that
      <span class="font-bold">Agoda homes does not match the calendar in Hostex</span>, and this
      <span class="font-bold">does not affect normal usage</span>. -->
    </div>

    <div [class]="footerClass">
      <button [class]="footerCancelBtnClass" nz-button nzSize="large" (click)="onCancel()">
        {{ "word.cancel" | translate }}
        <!-- Cancel -->
      </button>
      <button [class]="footerConfirmBtnClass" nz-button nzType="primary" nzSize="large" (click)="step = step + 1">
        {{ "channel-connect_booking_html_我明白了" | translate }}
        <!-- I understand and want to connect -->
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="step === 2">
    <div>
      <img class="w-[53px] h-[53px]" src="/assets/v4/icon-ctrip-color-bg.svg" alt="" />
      <img class="mx-2" src="/assets/v4/icon-link-arrow.svg" alt="" />
      <img class="w-[53px] h-[53px]" src="/assets/v4/icon-hostex-color.svg" alt="" />
    </div>

    <div class="text-l font-bold mt-[30px]">
      {{ "channel-connect_ctrip_html_标题" | translate }}
      <!-- Connect with Agoda -->
    </div>
    <div class="text-m mt-[30px]" [innerHTML]="'channel-connect_ctrip_html_关联之前须知' | translate">
      <!-- Before you start connecting, you need to
      <span class="font-bold"
        >contact Agoda's customer service or business manager and ask them for an connection with "CM Hostex"</span
      >
      (CM = Channel Manager). They have to do some settings for your connection. After they finished, go to next step. -->
    </div>
    <div [class]="footerClass">
      <button [class]="footerCancelBtnClass" nz-button nzSize="large" (click)="step = step - 1">
        {{ "word.return" | translate }}
        <!-- Back -->
      </button>
      <button [class]="footerConfirmBtnClass" nz-button nzType="primary" nzSize="large" (click)="step = step + 1">
        {{ "channel-connect_agoda_html_已经设置" | translate }}
        <!-- They have set Hostex as my CM -->
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="step === 3">
    <div class="text-l font-bold">
      {{ "channel-connect_ctrip_html_ctrip登录" | translate }}
      <!-- Enter your Agoda login -->
    </div>
    <div class="text-m mt-[30px]">
      {{ "channel-connect_ctrip_html_输入email" | translate }}
      <!-- Enter the email or username you use to log in to your Agoda account. -->
    </div>
    <div class="v4-layout-form mt-[30px]">
      <div class="v4-layout-field">
        <div class="v4-layout-field-control">
          <input
            type="text"
            nz-input
            nzSize="large"
            [placeholder]="'channel-connect_ctrip_html_ctrip登录' | translate"
            [(ngModel)]="username" />
        </div>
      </div>
    </div>
    <div [class]="footerClass">
      <button [class]="footerCancelBtnClass" nz-button nzSize="large" (click)="step = step - 1">
        {{ "word.return" | translate }}
        <!-- Back -->
      </button>
      <button
        [class]="footerConfirmBtnClass"
        nz-button
        nzType="primary"
        nzSize="large"
        [disabled]="!username"
        (click)="step = step + 1">
        {{ "word.next" | translate }}
        <!-- Next -->
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="step === 4">
    <div class="text-l font-bold">
      {{ "channel-connect_ctrip_html_输入hotelid" | translate }}
      <!-- Enter your hotel ID or listing ID -->
    </div>
    <div class="text-m mt-[30px]">
      {{ "channel-connect_ctrip_html_输入hotelid描述" | translate }}
      <!-- If you use Agoda homes, please enter your listing IDs, otherwise enter your hotel IDs. One per line, click on
      "Add" to add new lines. -->
    </div>
    <div class="v4-layout-form mt-[30px]">
      <div class="v4-layout-field" *ngFor="let hotel of hotelIds; first as isFirst; index as i">
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row relative">
            <input
              type="text"
              nz-input
              nzSize="large"
              [placeholder]="'channel-connect_with_ctrip_html_placeholder_id' | translate"
              [(ngModel)]="hotel.value" />
            <!-- <i
              *ngIf="!isFirst"
              class="cursor-pointer ml-[10px]"
              nz-icon
              nzType="minus-circle"
              nzTheme="fill"
              (click)="onRemoveHotelId(i)"></i> -->
          </div>
        </div>
      </div>
      <!-- <div class="v4-layout-field">
        <div class="v4-layout-field-control">
          <button nz-button (click)="onAddHotelId()">
            {{ "channel-connect_booking_html_添加" | translate }}
          </button>
        </div>
      </div> -->
    </div>
    <div [class]="footerClass">
      <button [class]="footerCancelBtnClass" nz-button nzSize="large" (click)="step = step - 1">
        {{ "word.return" | translate }}
        <!-- Back -->
      </button>
      <button
        [class]="footerConfirmBtnClass"
        nz-button
        nzType="primary"
        nzSize="large"
        (click)="onNext()"
        [nzLoading]="loading">
        {{ "word.next" | translate }}
        <!-- Next -->
      </button>
    </div>
  </ng-container>

  <!-- @if (step === 5) {
    <host-set-pricing-ratio (onBack)="step = 4" (onNext)="onFinish()"></host-set-pricing-ratio>
  } -->

  @if (step === 99) {
    <div class="text-l font-bold">
      {{ "channel-connect_ctrip_html_ctrip重新登录" | translate }}
      <!-- Enter your Agoda login -->
    </div>
    <div class="text-m mt-[30px]">
      {{ "channel-connect_ctrip_html_输入email" | translate }}
      <!-- Enter the email or username you use to log in to your Agoda account. -->
    </div>
    <div class="v4-layout-form mt-[30px]">
      <div class="v4-layout-field">
        <div class="v4-layout-field-control">
          <input
            type="text"
            nz-input
            nzSize="large"
            [placeholder]="'channel-connect_ctrip_html_ctrip登录' | translate"
            [(ngModel)]="username" />
        </div>
      </div>
    </div>
    <div [class]="footerClass">
      <button [class]="footerCancelBtnClass" nz-button nzSize="large" (click)="step = step - 1">
        {{ "word.return" | translate }}
        <!-- Back -->
      </button>
      <button
        [class]="footerConfirmBtnClass"
        nz-button
        nzType="primary"
        nzSize="large"
        [disabled]="!username"
        [nzLoading]="loading"
        (click)="onUpdateUsername()">
        {{ "word.save" | translate }}
      </button>
    </div>
  }
</div>
